function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6.46875 17.5H20.4688V13.8333H6.46875V17.5ZM6.46875 10.5833H20.4688V8.41667H6.46875V10.5833ZM6.46875 3V5.16667H20.4688V3H6.46875Z",
  fill: "currentColor"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3 22.1667V20V13.3323H5.16448L5.16448 20H21.7825L21.7825 13.3323H23.9387L23.9387 20V22.1667H3Z",
  fill: "currentColor"
});

function SvgBatteriesIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "static/2.3.2/media/batteriesIcon.bbb955db.svg";
export { SvgBatteriesIcon as ReactComponent };